module.exports = __webpack_public_path__ + "static/media/hand-holding-box.c9cbe7cb.svg";